export default __webpack_public_path__ + "assets/models/f0194d83f41cc9c02f0bc5b391aa3c61.glb";